import React from "react";

interface Props {
  buttonText: string;
  dataTest: string;
  onClick: any;
  classes?: string;
  infoSize?: boolean;
}

export default function ButtonCell({
  buttonText,
  dataTest,
  onClick,
  classes,
  infoSize,
}: Props) {
  return (
    <div
      className={`inline-button clickable text-cell ${
        infoSize ? "" : "double-height"
      } text-padding ${classes || ""}`}
      data-test={dataTest}
      onClick={onClick}
    >
      {buttonText}
    </div>
  );
}
